<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="workflow-products-page">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <WorkflowDetailProductsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import WorkflowDetailProductsView from "./WorkflowDetailProductsView.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import {
  type RoleGroup,
  ProductAppGroup,
  IngredientsAppGroup,
} from "@/shared/access/RoleGroups";

const main = useMainStore();

const roleGroups = [
  {
    roles: [...ProductAppGroup.roles, ...IngredientsAppGroup.roles],
  },
  {
    validateRestrictionsAsync: async () => {
      return (
        !main.companySummary || main.companySummary.AuthorizedOwnsIds.length > 0
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page {
  &__header--container {
    display: flex;
    align-items: center;
    margin-top: 30px;
    gap: 12px;
  }

  &__title--text {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-transform: uppercase;
  }
}
</style>
